export default {
  number2:['1','2','3','4','5','6','7','8','9','X','0','.'],
  biaodian:['@','#','$','￥','%','*','(',')','/','.','-',','],
  number:['1','2','3','4','5','6','7','8','9','0'],
  letter:['q','w','e','r','t','y','u','i','o','p','a','s','d','f','g','h','j','k','l','z','x','c','v','b','n','m'],
  cap_letter:['Q','W','E','R','T','Y','U','I','O','P','A','S','D','F','G','H','J','K','L','Z','X','C','V','B','N','M']
}